import { useSelector } from "react-redux";
import { TypedUseSelectorHook } from "react-redux";
import { IAppState } from "../interfaces";

export const useAppSelector: TypedUseSelectorHook<IAppState> = useSelector;
